import { FEATURE_ENUM } from '@partoohub/api-client';

import { useSubscriptions } from 'app/pages/app/AppDataProvider/hooks/useSubscriptions';

/**
 * Return if the user has at least one business with the feature
 */
export const useHasBusinessWithFeature = (feature: FEATURE_ENUM): boolean => {
    const subscriptions = useSubscriptions();
    return subscriptions.features.some(
        featureSubscription =>
            featureSubscription.feature_name === feature && featureSubscription.has_business,
    );
};
